module.exports = __webpack_public_path__ + "static/img/241_phase_function_Paper_PointsHejduk_Prediction.43f32c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/241_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Sb5u
// module chunks = 0